import { render } from "./TokenCard.vue?vue&type=template&id=258e287b&ts=true"
import script from "./TokenCard.vue?vue&type=script&lang=ts"
export * from "./TokenCard.vue?vue&type=script&lang=ts"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__